export const iconFontAwesomeHumanitarianPlugCircleMinus = (
	<i className="fa-solid fa-plug-circle-minus"></i>
);
